'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _UAHeader = require('./UAHeader');

var _UAHeader2 = _interopRequireDefault(_UAHeader);

var _UANav = require('./UANav');

var _UANav2 = _interopRequireDefault(_UANav);

var _UASection = require('./UASection');

var _UASection2 = _interopRequireDefault(_UASection);

var _themeManager2 = require('../../../../utilities/themeManager');

var _themeManager3 = _interopRequireDefault(_themeManager2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable import/no-extraneous-dependencies */


var htmlToReactParser = new _htmlToReact2.default.Parser();

var UserAgreement = function (_React$Component) {
  _inherits(UserAgreement, _React$Component);

  function UserAgreement(props) {
    _classCallCheck(this, UserAgreement);

    var _this = _possibleConstructorReturn(this, (UserAgreement.__proto__ || Object.getPrototypeOf(UserAgreement)).call(this, props));

    _this.setSection = function (sectionIndex) {
      _this.setState({
        currentSectionIndex: sectionIndex
        // currentSubSectionIndex: 0,
      });
    };

    _this.setSubSection = function (subSectionIndex) {
      _this.setState({
        currentSubSectionIndex: subSectionIndex
      });
    };

    _this.setNavRef = function (el) {
      _this.navRef = el;
    };

    _this.clickOutsideNav = function () {
      _this.closeMainNav();
      document.removeEventListener('mousedown', _this.handleDocumentClick, false);
    };

    _this.handleDocumentClick = function (e) {
      // dont close the nav if clicking inside the main nav
      if (_this.navRef.contains(e.target)) {
        return;
      }
      _this.clickOutsideNav();
    };

    _this.handleScroll = function () {
      _this.setState({
        scrollDirection: window.scrollY > _this.state.scrollY ? 'down' : 'up',
        scrollY: window.scrollY
      });
    };

    _this.openMainNav = function () {
      if (_this.state.isNavOpen) return;
      _this.setState({
        isNavOpen: true
      });
    };

    _this.closeMainNav = function () {
      if (!_this.state.isNavOpen) return;
      _this.setState({
        isNavOpen: false
      });
    };

    _this.handleMenuButtonClick = function () {
      // check if the menu is open / close and then take action
      if (_this.state.isNavOpen) {
        _this.closeMainNav();
        document.removeEventListener('mousedown', _this.handleDocumentClick, false);
      } else {
        _this.openMainNav();
        document.addEventListener('mousedown', _this.handleDocumentClick, false);
      }
    };

    _this.navRef = null;
    _this.state = {
      currentSectionIndex: 0,
      currentSubSectionIndex: -1,
      scrollDirection: 'down',
      scrollY: 0,
      isNavOpen: false
    };
    return _this;
  }

  _createClass(UserAgreement, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          config = _props.config,
          className = _props.className;
      var _state = this.state,
          currentSectionIndex = _state.currentSectionIndex,
          currentSubSectionIndex = _state.currentSubSectionIndex,
          scrollDirection = _state.scrollDirection,
          isNavOpen = _state.isNavOpen;
      var id = config.id,
          theme = config.theme;

      var _themeManager = (0, _themeManager3.default)({ content: this.props.content }, theme),
          content = _themeManager.content;

      var header = content.header,
          paragraph = content.paragraph,
          sections = content.sections,
          nav = content.nav;

      var uaClasses = (0, _classnames2.default)(className, 'user-agreement');
      return _react2.default.createElement(
        'section',
        {
          id: id,
          className: uaClasses,
          'data-building-block': 'organism',
          ref: function ref(el) {
            _this2.uaRef = el;
          }
        },
        _react2.default.createElement(_UANav2.default, _extends({
          sections: sections,
          currentSectionIndex: currentSectionIndex,
          currentSubSectionIndex: currentSubSectionIndex,
          isNavOpen: isNavOpen,
          setNavRef: this.setNavRef
        }, nav)),
        _react2.default.createElement(_UAHeader2.default, _extends({
          handleMenuClick: this.handleMenuButtonClick
        }, header)),
        _react2.default.createElement(
          'div',
          { className: 'ua-container' },
          paragraph && paragraph.text && _react2.default.createElement(
            'section',
            { className: 'ua-section' },
            _react2.default.createElement(
              'div',
              { className: 'containerCentered container' },
              _react2.default.createElement(
                'div',
                { className: 'span12 col-sm-12' },
                _react2.default.createElement(
                  'p',
                  { className: 'contentPara' },
                  htmlToReactParser.parse(paragraph.text)
                )
              )
            )
          ),
          sections.map(function (section, index) {
            return _react2.default.createElement(_UASection2.default, _extends({
              currentSectionIndex: currentSectionIndex,
              currentSubSectionIndex: currentSubSectionIndex,
              index: index,
              key: index + '-' + (section.anchorLink && section.anchorLink.text ? section.anchorLink.text : ''),
              scrollDirection: scrollDirection,
              setSection: _this2.setSection,
              setSubSection: _this2.setSubSection
            }, section));
          })
        )
      );
    }
  }]);

  return UserAgreement;
}(_react2.default.Component);

exports.default = UserAgreement;


UserAgreement.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-white'])
  }),
  content: _propTypes2.default.shape({
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    nav: _propTypes2.default.shape({
      backLink: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired,
        href: _propTypes2.default.string.isRequired
      }),
      pdf: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired,
        href: _propTypes2.default.string.isRequired
      })
    }),
    sections: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      anchorLink: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }),
      headline: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired,
      subsections: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        anchorLink: _propTypes2.default.shape({
          text: _propTypes2.default.string.isRequired
        }),
        headline: _propTypes2.default.shape({
          text: _propTypes2.default.string.isRequired
        }),
        paragraph: _propTypes2.default.shape({
          text: _propTypes2.default.string.isRequired
        }),
        table: _propTypes2.default.shape({
          text: _propTypes2.default.string.isRequired
        }),
        paragraph2: _propTypes2.default.shape({
          text: _propTypes2.default.string.isRequired
        })
      }))
    }))
  }),
  className: _propTypes2.default.string
};

UserAgreement.defaultProps = {
  content: {
    header: {
      title: {
        text: 'User Agreement'
      },
      menu: {
        text: 'Menu'
      }
    },
    paragraph: {
      text: 'This user agreement will be effective for all users as of March 29, 2019. Welcome to PayPal!<br/><br/><br/>We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, This user agreement is a contract between you and PayPal, Inc. governing your use of your PayPal account and the PayPal services. It applies to U.S. PayPal accounts only. If you are an individual, you must be a resident of the United States or one of its territories and at least 18 years old, or the age of majority in your state of residence to open a U.S. PayPal account and use the PayPal services. If you are a business, the business must be organized in, operating in, or a resident of, the United States or one of its territories to open a U.S. PayPal account and use the PayPal services.'
    },
    nav: {
      backLink: {
        href: '#',
        text: 'Back to All Agreements'
      },
      pdf: {
        text: 'Download Printable PDF',
        href: 'https://www.paypalobjects.com/digitalassets/c/website/ua/pdf/US/en/ppwallet.pdf'
      }
    },
    sections: [{
      anchorLink: {
        text: ''
      },
      id: 'item-1',
      headline: {
        text: 'About Your Account'
      },
      subsections: [{
        anchorLink: {
          text: ''
        },
        id: 'item-2',
        headline: {
          text: 'First headline'
        },
        paragraph2: {
          text: 'We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/> We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/> We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/> We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/>'
        },
        table: {
          text: '<table class="ppvx_table"><tbody><tr><td><p>Currency</p></td><td><p>Fee</p></td></tr><tr><td><p>U.S. Dollar</p></td><td><p>0.30 USD</p></td></tr><tr><td><p>Euro</p></td><td><p>0.35 EUR</p></td></tr></tbody></table>'
        }
      }, {
        anchorLink: {
          text: ''
        },
        headline: {
          text: 'Opening a PayPal Account'
        },
        paragraph: {
          text: 'We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, This user agreement is a contract between you and PayPal, Inc. governing your use of your PayPal account and the PayPal services. It applies to U.S. PayPal accounts only. If you are an individual, you must be a resident of the United States or one of its territories and at least 18 years old, or the age of majority in your state of residence to open a U.S. PayPal account and use the PayPal services. If you are a business, the business must be organized in, operating in, or a resident of, the United States or one of its territories to open a U.S. PayPal account and use the PayPal services.'
        },
        table: {
          text: '<table class="ppvx_table"><tbody><tr><td><p>Currency</p></td><td><p>Fee</p></td></tr><tr><td><p>U.S. Dollar</p></td><td><p>0.30 USD</p></td></tr><tr><td><p>Euro</p></td><td><p>0.35 EUR</p></td></tr></tbody></table>'
        },
        paragraph2: {
          text: 'We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/> We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/> We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/> We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/>'
        },
        id: 'item-3'
      }]
    }, {
      anchorLink: {
        text: ''
      },
      headline: {
        text: 'About Your Account'
      },
      subsections: [{
        anchorLink: {
          text: ''
        },
        headline: {
          text: 'Opening a PayPal Account'
        },
        paragraph: {
          text: 'We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, This user agreement is a contract between you and PayPal, Inc. governing your use of your PayPal account and the PayPal services. It applies to U.S. PayPal accounts only. If you are an individual, you must be a resident of the United States or one of its territories and at least 18 years old, or the age of majority in your state of residence to open a U.S. PayPal account and use the PayPal services. If you are a business, the business must be organized in, operating in, or a resident of, the United States or one of its territories to open a U.S. PayPal account and use the PayPal services.'
        },
        table: {
          text: '<table class="ppvx_table"><tbody><tr><td><p>Currency</p></td><td><p>Fee</p></td></tr><tr><td><p>U.S. Dollar</p></td><td><p>0.30 USD</p></td></tr><tr><td><p>Euro</p></td><td><p>0.35 EUR</p></td></tr></tbody></table>'
        },
        paragraph2: {
          text: 'We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/> We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/> We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/> We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/>'
        },
        id: 'item-7'
      }, {
        anchorLink: {
          text: ''
        },
        headline: {
          text: 'Opening a PayPal Account'
        },
        paragraph: {
          text: 'We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, This user agreement is a contract between you and PayPal, Inc. governing your use of your PayPal account and the PayPal services. It applies to U.S. PayPal accounts only. If you are an individual, you must be a resident of the United States or one of its territories and at least 18 years old, or the age of majority in your state of residence to open a U.S. PayPal account and use the PayPal services. If you are a business, the business must be organized in, operating in, or a resident of, the United States or one of its territories to open a U.S. PayPal account and use the PayPal services.'
        },
        table: {
          text: '<table class="ppvx_table"><tbody><tr><td><p>Currency</p></td><td><p>Fee</p></td></tr><tr><td><p>U.S. Dollar</p></td><td><p>0.30 USD</p></td></tr><tr><td><p>Euro</p></td><td><p>0.35 EUR</p></td></tr></tbody></table>'
        },
        paragraph2: {
          text: 'We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/> We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/> We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/> We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/>'
        },
        id: 'item-8'
      }, {
        anchorLink: {
          text: ''
        },
        headline: {
          text: 'Opening a PayPal Account'
        },
        paragraph: {
          text: 'We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, This user agreement is a contract between you and PayPal, Inc. governing your use of your PayPal account and the PayPal services. It applies to U.S. PayPal accounts only. If you are an individual, you must be a resident of the United States or one of its territories and at least 18 years old, or the age of majority in your state of residence to open a U.S. PayPal account and use the PayPal services. If you are a business, the business must be organized in, operating in, or a resident of, the United States or one of its territories to open a U.S. PayPal account and use the PayPal services.'
        },
        table: {
          text: '<table class="ppvx_table"><tbody><tr><td><p>Currency</p></td><td><p>Fee</p></td></tr><tr><td><p>U.S. Dollar</p></td><td><p>0.30 USD</p></td></tr><tr><td><p>Euro</p></td><td><p>0.35 EUR</p></td></tr></tbody></table>'
        },
        paragraph2: {
          text: 'We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/> We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/> We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/> We offer two types of PayPal accounts: personal PayPal accounts and business PayPal account, both covered by this user agreement.<br/>'
        },
        id: 'item-9'
      }],
      id: 'item-6'
    }]
  },
  config: {
    id: 'UserAgreement',
    theme: 'theme-background-color-white'
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/user-agreement/jsx/UserAgreement.js
// module id = 1157
// module chunks = 4